import { useQuery } from "@tanstack/react-query";
import ChannelConnectionsAdminService from "services/admin/channelConnections";

export const useGetChannelConnections = (queryParams = {}) => {
    return useQuery({
        queryKey: ['channel-connections', queryParams],
        queryFn: async () => {
            const { data } = await ChannelConnectionsAdminService.getAll({
                ...queryParams,
            });
            return data;
        },
        refetchOnWindowFocus: false,
    });
};